'use strict';

import './aui/header-async';

export default window.AJS;



// WEBPACK FOOTER //
// src/js/aui-header-async.js